import { fetchAuth } from './authService';

const API = process.env.REACT_APP_API_URL;

const get = (url)       => fetchAuth(url);
const put = (url, body) => fetchAuth(url, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

export async function getBrandVoiceTemplates() {
  const res = await get(`${API}/config/pulse/brand-voice/templates`);
  if (!res.ok) throw new Error('Failed to load templates.');
  const data = await res.json();
  return data.templates;
}

export async function getBrandVoice() {
  const res = await get(`${API}/config/pulse/brand-voice`);
  if (!res.ok) throw new Error('Failed to load brand voice config.');
  return res.json();
}

export async function saveBrandVoice(templateId) {
  const res = await put(`${API}/config/pulse/brand-voice`, { config: { templateId } });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to save.');
  return data;
}

export async function getHumanSupport() {
  const res = await get(`${API}/config/pulse/human-support`);
  if (!res.ok) throw new Error('Failed to load human support config.');
  return res.json();
}

export async function saveHumanSupport(supportEmail) {
  const res = await put(`${API}/config/pulse/human-support`, { config: { supportEmail } });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to save.');
  return data;
}

export async function getBrandIdentity() {
  const res = await get(`${API}/config/pulse/brand-identity`);
  if (!res.ok) throw new Error('Failed to load brand identity config.');
  return res.json();
}

export async function saveBrandIdentity(config) {
  const res = await put(`${API}/config/pulse/brand-identity`, { config });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to save.');
  return data;
}

export async function getPromptConfig() {
  const res = await get(`${API}/config/pulse/prompt`);
  if (!res.ok) throw new Error('Failed to load prompt config.');
  return res.json();
}

export async function savePromptConfig(systemPrompt) {
  const res = await put(`${API}/config/pulse/prompt`, { config: { systemPrompt } });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to save.');
  return data;
}

export async function getWidgetKey() {
  const res = await get(`${API}/company/widget-key`);
  if (!res.ok) throw new Error('Failed to load widget key.');
  return res.json();
}

export async function getWebsiteConfig() {
  const res = await get(`${API}/config/pulse/website`);
  if (!res.ok) throw new Error('Failed to load website config.');
  return res.json();
}

export async function saveWebsiteConfig(websiteUrl) {
  const res = await put(`${API}/config/pulse/website`, { config: { websiteUrl } });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to save.');
  return data;
}

export async function trainWebsite() {
  const res = await fetchAuth(`${API}/crawl`, { method: 'POST' });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to start training.');
  return data;
}

export async function getCrawlStatus() {
  const res = await get(`${API}/crawl/status`);
  if (!res.ok) throw new Error('Failed to load crawl status.');
  return res.json();
}

export async function getUsage() {
  const res = await fetchAuth(`${API}/usage/pulse`);
  if (!res.ok) throw new Error('Failed to load usage.');
  return res.json();
}
